import {
    SAVE_RAZAS_PROTECTORA,
    CHANGE_ESPECIE_SELECCIONADA_PROTECTORA,
    CHANGE_SEXO_SELECCIONADO_PROTECTORA,
    CHANGE_TAMANIOS_SELECCIONADOS_PROTECTORA,
    CHANGE_EDADES_SELECCIONADAS_PROTECTORA,
    CHANGE_RAZA_SELECCIONADA_PROTECTORA,
    CHANGE_AVANZADO_FILTER_PROTECTORA,
    SAVE_ESTADOS_ANIMAL_PROTECTORA,
    CHANGE_ESTADO_SELECCIONADO_PROTECTORA,
    SAVE_COLORES_ANIMAL_PROTECTORA,
    CHANGE_COLORES_SELECCIONADOS_PROTECTORA,
    SAVE_CARACTERS_ANIMAL_PROTECTORA,
    CHANGE_CARACTERS_SELECCIONADOS_PROTECTORA,
    CHANGE_CHIP_SELECCIONADO_PROTECTORA,
    CHANGE_VACUNA_SELECCIONADA_PROTECTORA,
    CHANGE_PPP_SELECCIONADO_PROTECTORA,
    RESET_FILTERS_PROTECTORA
} from '../actions/actionsFilterAnimals'

import {MAP_PROPS_ANIMAL_CONFIG} from "@/config/globalAnimalFrontEndConfig";


const initial_filtroAnimalSeleccionado = {
    especie: MAP_PROPS_ANIMAL_CONFIG.especie.default.value,
    sexo: MAP_PROPS_ANIMAL_CONFIG.sexo.default.value,
    tamano: [],
    edades: [],
    raza: undefined,
    // estado: "",
    colores: [MAP_PROPS_ANIMAL_CONFIG.color.default.label],
    // caracters: [],
    // chip: undefined,
    // vacuna: undefined,
    // ppp: undefined,
    // estadoUrgente: undefined
};
const initialState = {

    filtroAnimalSeleccionado: initial_filtroAnimalSeleccionado,
    errorFiltro: undefined,
    config: {
        elementsPerPage: 30,
        elementsPerRow: 1,
        showListing: true,
        showMap: true,
        mobileMode: true,
        pagNum: 0,
        avanzado: false,
    },

    params: {
        razas: {
            perro: [],
            gato: [],
        },
        estados: Object.values(MAP_PROPS_ANIMAL_CONFIG["estado"]).filter(t => t.nameProp !== "default") || [],
        colores: Object.values(MAP_PROPS_ANIMAL_CONFIG["color"]).filter(t => t.nameProp !== "default") || [],
        caracters: Object.values(MAP_PROPS_ANIMAL_CONFIG["caracter"]).filter(t => t.nameProp !== "default") || [],
        edades: Object.values(MAP_PROPS_ANIMAL_CONFIG["edad"]).filter(t => t.nameProp !== "default") || [],
        tamano: Object.values(MAP_PROPS_ANIMAL_CONFIG["tamano"]).filter(t => t.nameProp !== "default") || [],
    },

};

export function reducerFiltersAnimalsProtectora(state = initialState, action) {

	switch (action.type) {
        case SAVE_RAZAS_PROTECTORA:
            return Object.assign({}, state, {
                params: {
                    ...state.params,
                    razas: {
                        ...state.params.razas,
                        ...action.payload.razas
                    },
                }
            });
            // case SAVE_RAZAS_PERRO_PROTECTORA:
		// 	return {...state, razasPerro: action.payload.razasPerro};
        // case SAVE_RAZAS_GATO_PROTECTORA:
        //     return {...state, razasGato: action.payload.razasGato};
        case CHANGE_ESPECIE_SELECCIONADA_PROTECTORA:
            return {...state, especieSeleccionada: action.payload.especieSeleccionada};
        case CHANGE_SEXO_SELECCIONADO_PROTECTORA:
            return {...state, sexoSeleccionado: action.payload.sexoSeleccionado};
        case CHANGE_TAMANIOS_SELECCIONADOS_PROTECTORA:
            return {...state, tamaniosSeleccionados: action.payload.tamaniosSeleccionados};
        case CHANGE_EDADES_SELECCIONADAS_PROTECTORA:
            return {...state, edadesSeleccionadas: action.payload.edadesSeleccionadas};
        case CHANGE_RAZA_SELECCIONADA_PROTECTORA:
            return {...state, razaSeleccionada: action.payload.razaSeleccionada};
        case CHANGE_AVANZADO_FILTER_PROTECTORA:
            return {...state, avanzado: action.payload.avanzado};
        case SAVE_ESTADOS_ANIMAL_PROTECTORA:
            return Object.assign({}, state, {
                params: {
                    ...state.params,
                    estados: action.payload.estadosAnimal,
                }
            });
        case CHANGE_ESTADO_SELECCIONADO_PROTECTORA:
            return {...state, estadoAnimalSeleccionado: action.payload.estadoAnimalSeleccionado};
        case SAVE_COLORES_ANIMAL_PROTECTORA:
            // return {...state, colores: action.payload.colores};
            return Object.assign({}, state, {
                params: {
                    ...state.params,
                    colores: action.payload.colores,
                }
            })
        case CHANGE_COLORES_SELECCIONADOS_PROTECTORA:
            return {...state, coloresAnimalSeleccionados: action.payload.coloresAnimalSeleccionados};
        case SAVE_CARACTERS_ANIMAL_PROTECTORA:
            // return {...state, caracters: action.payload.caracters};
            return Object.assign({}, state, {
                params: {
                    ...state.params,
                    caracters: action.payload.caracters,
                }
            })
        case CHANGE_CARACTERS_SELECCIONADOS_PROTECTORA:
            return {...state, caractersAnimalSeleccionados: action.payload.caractersAnimalSeleccionados};
        case CHANGE_CHIP_SELECCIONADO_PROTECTORA:
            return {...state, chipSeleccionado: action.payload.chipSeleccionado};
        case CHANGE_VACUNA_SELECCIONADA_PROTECTORA:
            return {...state, vacunaSeleccionada: action.payload.vacunaSeleccionada};
        case CHANGE_PPP_SELECCIONADO_PROTECTORA:
            return {...state, pppSeleccionado: action.payload.pppSeleccionado};
        case RESET_FILTERS_PROTECTORA:
            return {
                ...state,
                ...initialState
            };
		default:
			return state
	}
}